import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Divider
} from '@mui/material';
import logo from "./../assets/gaussian_logo.png";
import InfoIcon from '@mui/icons-material/Info';

export default function TopBar() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar variant="dense" sx={{ px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center'}}>       
              <img style={{ width: 'auto', maxHeight: '30px', marginRight: 16 }} src={logo} alt="Gaussian Logo" />
              <Typography variant="h6" color="inherit" sx={{ marginTop: '5px' }}>
                Road Sign Detection And Localization Demo
              </Typography>        
          </Box>
          <InfoIcon sx={{ color: '#000080', cursor: 'pointer' }} onClick={handleOpen} />
        </Toolbar>
      </AppBar>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>About This Demo</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            This demo showcases detection and localization of roadside elements using AI-powered image processing. The system extracts multiple features from roadway imagery:
          </DialogContentText>

          <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
            <li><strong>Traffic Signs:</strong> Stop signs, yield signs, speed limits, traffic lights, lane merges, bike routes, and more.</li>
            <li><strong>Sidewalks & Curbs:</strong> Sidewalk boundaries and curb locations are detected to assess pedestrian infrastructure.</li>
            <li><strong>Polygons & Bounding Boxes:</strong> Inferred object locations are visualized with precise bounding boxes and polygons for spatial reference.</li>
          </ul>

          <Divider sx={{ my: 2 }} />

          <DialogContentText>
            Select any marker on the map to view its associated image, inferred features, and geometric overlays.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" sx={{ backgroundColor: '#000080' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
